import type { SVGProps } from 'react';
const SvgUpdateStreamlineCoreLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <desc>{'Triangle Arrow Rotate Right 2 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.84 2.66A6.5 6.5 0 1 0 13.423 8" />
      <path d="M13.5 4.5H10L13.5 1z" />
    </g>
  </svg>
);
export default SvgUpdateStreamlineCoreLine;
